export default __webpack_public_path__ + "static/media/25.71ad1238.png";